import { BaseConfigService } from '@lx/shared/app-config';
import { CoreEnvironment, EnvironmentAndConfiguration } from '@lx/shared/types';

// Initialization factory function
export function configFactory(env: CoreEnvironment, configService: BaseConfigService): () => Promise<EnvironmentAndConfiguration> {
  return () => {
    return configService.getEnvironmentAndConfiguration(env);
  };
}
